<template>
    <label class="tw:inline-flex tw:items-center tw:cursor-pointer tw:select-none">
        <input type="hidden" :value="value"> <!-- por si se requiere enviar en forms -->
        <div class="tw:relative">
            <input type="checkbox" class="tw:sr-only tw:peer" :checked="value"
                @change="$emit('input', $event.target.checked)">
            <div
                class="tw:w-9.5 tw:h-5 tw:bg-slate-200 tw:peer-focus:outline-none tw:rounded-full tw:peer tw:peer-checked:after:translate-x-full tw:peer-checked:after:border-white tw:after:content-[''] tw:after:absolute tw:after:top-[1px] tw:after:left-[1px] tw:after:bg-white tw:after:border-slate-300 tw:border tw:border-slate-300 tw:after:rounded-full tw:after:h-4.5 tw:after:w-4.5 tw:after:transition-all tw:peer-checked:bg-primary">
            </div>
        </div>
        <span class="tw:ml-3 tw:text-sm tw:font-medium tw:text-slate-700" v-if="label">{{ label }}</span>
    </label>
</template>

<script>
export default {
    name: 'BaseToggle',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    }
}
</script>